import { FC, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../redux/AppReducer';
import {
	Route,
	Routes,
	BrowserRouter as Router,
	Navigate,
	useLocation,
	Outlet,
	useParams
} from 'react-router';
import Layout from '../components/Layout';
import ProductDetail from '../pages/ProductDetail';
import ProductsPage from '../pages/Products';
import { ProfilePage } from '../pages/Profile/index';
import OnbordingPage from '../pages/Onbording/index';
import BrandDatail from '../pages/BrandDetail/index';
import LandingPage from '../pages/LandingPage/index';
import { GeneralError } from '../pages/GeneralError/index';
import { PROFILE_ROUTES } from '../common/constants';
import { AppActions } from '../redux/AppActions';
import Home from '../pages/HomePage';
import UnsubscribePage from '../pages/Unsubscribe';
import BrandBusinessProvider from '../pages/BrandBussinesProvider';
import BusinessProvidersPage from '../pages/BusinessProviders/index';
import { useAppDispatch } from '../redux/store';
import CompanyDetailsComponent from '../components/authentication/company-details/CompanyDetailsComponent';
import BrandOnboard from '../pages/BrandOnboard';
import FAQComponent from '../components/NewProfile/FAQComponent/FAQComponent';
import ArticlesPage from '../pages/Articles';
import AboutPage from '../pages/About';
import Shopify from '../pages/ShopifyPage';
import VideoPage from '../pages/VideoPage';

const PublicRedirect = () => {
	const location = useLocation();
	const { '*': rest } = useParams<{ '*': string }>();
	const cleanBase = rest ? `/${rest}` : '/';
	const targetPath = cleanBase + location.search;
	return <Navigate to={targetPath} replace />;
};

const LoginRedirect = ({ isAuthenticated }: { isAuthenticated?: boolean }) => {
	let redirectTo = <Navigate to='/' replace />;
	if (isAuthenticated) {
		redirectTo = <Outlet />;
	}
	return redirectTo;
};

const useCompanyDetails = () => {
	const dispatch = useAppDispatch();

	const hasCompanyDetails = useSelector(
		({ appState: state }: RootState) => state.userState?.hasCompanyDetails
	);

	const hasLoadProfile = useSelector(
		({ appState: state }: RootState) => state.userState?.hasLoadProfile
	);

	useEffect(() => {
		if (hasLoadProfile && !hasCompanyDetails) {
			if (window.location.pathname !== '/' && window.location.pathname !== '/landing') {
				window.location.href = '/landing';
			}
			dispatch(
				AppActions.setModalContent({
					content: <CompanyDetailsComponent />,
					showCloseIcon: true,
					canScroll: true,
					isCompanyDetailsModal: true,
					closeOnDocumentClick: false
				})
			);
		}
	}, [hasLoadProfile, hasCompanyDetails]);
};

const AppRoutes: FC = () => {
	const isAuthenticated = useSelector(
		({ appState: state }: RootState) => state.authState?.isAuthenticated
	);

	useCompanyDetails();

	return (
		<Router>
			<Routes>
				<Route element={<Layout isAuthenticated={isAuthenticated} />}>
					<Route>
						<Route path='/' index element={<Home />}></Route>
						<Route path='/home' element={<Home />} />
						<Route path='/products' element={<ProductsPage />} />
						<Route path='/detail/:id' element={<ProductDetail />} />
						<Route path='/businessProviders' element={<BusinessProvidersPage />} />
						<Route path='/brand/:brandId' element={<BrandDatail />} />
						<Route path='/businessProvider/:brandId' element={<BrandBusinessProvider />} />
						<Route
							path={`/${PROFILE_ROUTES.GET_ON_BEACON}`}
							element={isAuthenticated ? <ProfilePage /> : <BrandOnboard />}
						/>
						<Route path='/beaconFAQ' element={<FAQComponent isGeneral />} />
						<Route path='/about' element={<AboutPage />} />
						<Route path='/shopify' element={<Shopify />} />
						<Route path='article/:articleId' element={<ArticlesPage />} />

						<Route path='video/:videoId' element={<VideoPage />} />
					</Route>
					<Route element={<LoginRedirect isAuthenticated={isAuthenticated}></LoginRedirect>}>
						<Route path='/landing' element={<LandingPage />} />
						<Route path='/onboarding' element={<OnbordingPage />} />
						<Route path={`/${PROFILE_ROUTES.PROFILE}`} element={<ProfilePage />} />
						<Route path={`/${PROFILE_ROUTES.BRAND_INFO}`} element={<ProfilePage />} />
						<Route path={`/${PROFILE_ROUTES.PRODUCT_INFO}`} element={<ProfilePage />} />
						<Route path={`/${PROFILE_ROUTES.ONBOARD_FAQ}`} element={<ProfilePage />} />
						<Route path={`/${PROFILE_ROUTES.INGREDIENTS}`} element={<ProfilePage />} />
						<Route path={`/${PROFILE_ROUTES.FAVORITES}`} element={<ProfilePage />} />
						<Route path={`/${PROFILE_ROUTES.SOCIALMEDIA_KIT}`} element={<ProfilePage />} />
						<Route path='*' element={<GeneralError />} />
					</Route>
				</Route>
				<Route>
					<Route path='/public' element={<PublicRedirect />} />
					<Route path='/public/*' element={<PublicRedirect />} />
					<Route path='/unsubscribe/:email' element={<UnsubscribePage />} />
				</Route>
			</Routes>
		</Router>
	);
};

export default AppRoutes;
